module.exports = __webpack_public_path__ + "static/image/history/pc/201601@3x.jpg?2d20dabb";